import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#04070d",
          color: "#e8f0ff",
          padding: 32,
          overflow: "auto",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
        }}
      >
        <h1 style={{ color: "#ff8888", fontSize: 18, margin: "0 0 12px" }}>
          Something crashed
        </h1>
        <pre
          style={{
            background: "rgba(255,136,136,0.08)",
            border: "1px solid rgba(255,136,136,0.3)",
            borderRadius: 8,
            padding: 16,
            fontSize: 13,
            lineHeight: 1.5,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            maxHeight: "60vh",
            overflow: "auto",
          }}
        >
          {error.message}
          {"\n\n"}
          {error.stack}
        </pre>
        <button
          type="button"
          onClick={() => {
            this.setState({ error: null });
            window.location.reload();
          }}
          style={{
            marginTop: 16,
            background: "#7eb8ff",
            color: "#04070d",
            border: 0,
            borderRadius: 8,
            padding: "10px 20px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}
